import Inputmask from "inputmask";


export default function mask() {

    const maskEmail = document.querySelectorAll('[data-mask-email]');
    const maskName = document.querySelectorAll('[data-mask-name]');
    const maskPass = document.querySelectorAll('[data-mask-pass]');
    const maskNumber = document.querySelectorAll('[data-mask-number]');

    if ( maskEmail.length ) {
        for (let el of maskEmail ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Z0-9@._-]/g, '');
            });
        }
    }

    if ( maskName.length ) {
        for (let el of maskName ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Zа-яА-ЯёЁ ]/g, '');
            });
        }
    }

    if (maskPass.length) {
        for (let el of maskPass) {
            el.addEventListener('input', function(e) {
                // Разрешаем: английские буквы (a-z, A-Z), цифры (0-9) и стандартные символы
                this.value = this.value.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~ ]/g, '');
            });
        }
    }

    if (maskNumber.length) {
        for (let el of maskNumber) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^0-9]/g, '');
            });
        }
    }

    if(document.querySelectorAll('input[data-mask-tel]').length > 0) {
        let selector = document.querySelectorAll('input[data-mask-tel]');
        let im = new Inputmask('+7 (999) 999-99-99', {
        showMaskOnHover: false,
        });
        im.mask(selector);

    }

    initRequiredValidation();
}

function getFieldErrorEl(input) {
    const parent = input.closest('.hero__form-field, .modal__form-field, .hero__form-label, .modal__form-label');
    return parent?.querySelector('.hero__form-error, .modal__form-error');
}

function setFieldError(input, message) {
    input.setCustomValidity(message);
    const errorEl = getFieldErrorEl(input);
    if (errorEl && message) {
        errorEl.textContent = message;
    }
}

function getPhoneDigits(value) {
    return value.replace(/\D/g, '');
}

function validatePhone(input) {
    const digits = getPhoneDigits(input.value);

    if (!digits || digits === '7') {
        setFieldError(input, 'Обязательное поле для заполнения');
    } else if (digits.length < 11) {
        setFieldError(input, 'Неверный формат телефона');
    } else {
        setFieldError(input, '');
    }
}

function validateEmail(input) {
    const value = input.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value) {
        setFieldError(input, 'Обязательное поле для заполнения');
    } else if (!emailRegex.test(value)) {
        setFieldError(input, 'Неверный формат email');
    } else {
        setFieldError(input, '');
    }
}

function validateCheckbox(input) {
    if (!input.checked) {
        setFieldError(input, 'Необходимо принять условия политики конфиденциальности');
    } else {
        setFieldError(input, '');
    }
}

function validateRequiredInput(input) {
    if (input.matches('[data-mask-tel]')) {
        validatePhone(input);
    } else if (input.matches('[data-mask-email]')) {
        validateEmail(input);
    } else if (input.type === 'checkbox') {
        validateCheckbox(input);
    }
}

function initRequiredValidation() {
    const requiredInputs = document.querySelectorAll('[data-required]');

    requiredInputs.forEach((input) => {
        const validate = () => validateRequiredInput(input);

        input.addEventListener('invalid', (e) => e.preventDefault());
        input.addEventListener('input', validate);
        input.addEventListener('blur', validate);
        input.addEventListener('change', validate);
    });

    document.querySelectorAll('.js-form').forEach((form) => {
        form.noValidate = true;

        form.addEventListener('submit', (e) => {
            let isValid = true;

            form.querySelectorAll('[data-required]').forEach((input) => {
                validateRequiredInput(input);
                if (!input.checkValidity()) {
                    isValid = false;
                }
            });

            if (!isValid) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }, true);
    });
}